import { PutOrderAdmin } from "../../../../services/OrderService";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import moment from "moment";

function normalizeOrderDatePayload(value: string) {
	const parsed = moment(value, ["YYYY-MM-DD", moment.ISO_8601], true);
	return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
}

export default function useUpdateOrderAdmin(props: { reload?: () => void; orderId: number }) {
	const { openAlertDialog } = useAlertDialog();
	const updateOrderAd = async (
		partnerId: number | undefined,
		timeIn: string,
		timeOut: string,
		quantity: string,
		paymentMethod: string,
		totalMoney: string,
		status: string,
		customerUserId: number,
		allowPartnerId: boolean,
		pastDateReason?: string,
	) => {
		const newTimeIn = normalizeOrderDatePayload(timeIn);
		const newTimeOut = normalizeOrderDatePayload(timeOut);
// 		console.log("newTimeIn", newTimeIn);
//   console.log("newTimeOut", newTimeOut);
//   console.log("timeIn", timeIn);
//   console.log("timeOut", timeOut);
		try {
			await PutOrderAdmin(
				props.orderId,
				partnerId,
				newTimeOut,
				newTimeIn,
				quantity,
				paymentMethod,
				totalMoney,
				status,
				customerUserId,
				allowPartnerId,
				pastDateReason
			);
			props.reload?.();
		} catch (err: any) {
			// 31/10/2026: hiện đúng lý do backend chặn (vd sửa ngày quá khứ mà không phải super admin)
			openAlertDialog?.(AlertType.Fail, err?.response?.data?.message || "Đã có lỗi xảy ra!");
			console.error(err);
		}
	};

	return {
		updateOrderAd,
	};
}
